import { createContext } from 'react';
import type { MouseEvent } from 'react';
import type { BoardCard } from '@nightshift/ui-types';

export const BoardSelectionContext = createContext<{
  cards: readonly BoardCard[];
  select: (card: BoardCard, stack: readonly BoardCard[], event: MouseEvent) => void;
} | null>(null);
